import { type Appointment, type Task, isTask } from "@repo/api";

import { type OutlookEvent } from "../types";

export const filterVisibleTasks = (
  items: (Task | Appointment | OutlookEvent)[]
) =>
  items.filter((item) => {
    if (!isTask(item)) {
      return true;
    }

    return true;
  });
